export const countDrawErrors = (
  drawObj: any,
  selectedBankDetails: any,
  // The routing value visible in the edit input (decrypted plaintext / freshly typed).
  // Used for the 9-digit rule instead of selectedBankDetails.routing, which can be a
  // masked last-4 carried over from a previous draw and would falsely fail validation.
  visibleRouting?: string
) => {
  let loanerrorCount = 0;
  const { drawAmountDetails } = drawObj;
  const fieldsToIgnore = [
    "drawId", // drawId comes from route (URL), not always on draw object from API
    "drawAmountDetails",
    "balanceToFinish",
    "originatorId",
    "propertyDetailsOptions",
    "drawType",
    "loanStatus",
    "finalApproval",
    "finalApprovalNotRequired",
    "originalMaturityDate", // todo:remove these below fields later
    "maturityDate",
    "currentMaturityDate",
    "nextPaymentDueDate",
    "gracePeriod",
    "payOffRequestDate",
    "availableFinancedBudgetAmount",
    "drawType",
    "loanExcelJson",
    "originatorName",
    "servicerId",
    "servicerName",
    "borrowerAddress",
    "requestedDate",
    "lastUpdatedDate",
    "documentTaggingStatus",
    "budgetReconcileStatus",
    "inspectionReviewStatus",
    "budgetReviewStatus",
    "prePurchaseDrawAmount",
    "brokerName",
    "originatingEntity",
    "sellerName",
    "fundingChannel",
    "fpiFlag",
    "repeatBorrower",
    "repeatBankDetailsDrawList",
    "losDrawId",
    "drawAmountType"
  ];

  Object.keys(drawObj).forEach((field) => {
    if (fieldsToIgnore.includes(field)) return;

    // Special handling for propertyDetails: require at least one property selected.
    if (field === "propertyDetails") {
      const props = drawObj.propertyDetails;
      if (!Array.isArray(props) || props.length === 0) {
        console.error("field Error:", field);
        loanerrorCount++;
      }
      return;
    }

    if (!drawObj[field]) {
      console.error("field Error:", field);
      loanerrorCount++;
    }
  });

  Object.keys(drawAmountDetails).forEach((field) => {
    if (["edited", "stage", "comments"].includes(field)) return;
    let isZeroNetFunds = false;
    if (field === "netFundsToBorrower") {
      isZeroNetFunds = drawAmountDetails[field] === "0.00";
    }

    if (
      (!drawAmountDetails[field] && drawAmountDetails[field] !== 0) ||
      isZeroNetFunds
    ) {
      console.error("field Error:", field);
      loanerrorCount++;
    }
  });

  if (selectedBankDetails) {
    Object.keys(selectedBankDetails).forEach((field) => {
      if (
        [
          "netFundsToBorrower",
          "edited",
          "bankDetailId",
          "borrowerEntityName",
          "updatedBy",
          "needsDrawIdDecrypt",
          "accountNumberEncryptionId",
          "routingEncryptionId",
          "accountNameEncryptionId",
          "isEncrypted",
          "losBankDetailId"
        ].includes(field)
      )
        return;
      if (!selectedBankDetails[field]) {
        console.error("field Error:", field);
        loanerrorCount++;
        return;
      }
      if (field === "routing") {
        // Validate the value the user actually sees in the input. When visibleRouting
        // is empty the field still shows the stored (masked) value — whose real routing
        // is a valid 9-digit number — so the presence check above is enough and we don't
        // flag the 9-digit rule here.
        const routingToCheck = String(visibleRouting ?? "");
        if (routingToCheck && routingToCheck.length !== 9) {
          console.error("field Error:", field);
          loanerrorCount++;
        }
      }
    });
  } else {
    loanerrorCount += 4;
  }
  return loanerrorCount;
};